import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import type * as React from "react";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none",
  {
    variants: {
      variant: {
        default: "border-transparent bg-primary text-primary-foreground",
        secondary: "border-transparent bg-secondary text-secondary-foreground",
        destructive: "border-transparent bg-destructive text-destructive-foreground",
        outline: "text-foreground border-border",
        ok: "border-green-500/40 bg-green-500/10 text-green-700 dark:text-green-400",
        warn: "border-amber-500/40 bg-amber-500/10 text-amber-700 dark:text-amber-400",
        err: "border-red-500/40 bg-red-500/10 text-red-700 dark:text-red-400",
        lemon:
          "border-[hsl(var(--lemon))]/40 bg-[hsl(var(--lemon))]/15 text-yellow-800 dark:text-yellow-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
